import React, { useState, useEffect } from 'react';
import { Badge, Menu, Dropdown, Descriptions, Tabs, Tag, Space, DatePicker, Search, Card, Radio, Form, notification, message, Row, Modal, Upload, Col, Input, Image, Select, Divider, Table, Button } from 'antd';
import { SearchOutlined, PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
//import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
import { fetchData, sendData, sendDataPut } from'../../../httpRequests';
import Item from 'antd/lib/list/Item';
import { async } from '@firebase/util';
import moment from 'moment';
import { ExportExcel } from '../../../components/ExportExcel/ExportExcel';
import { formatter } from '../../../components/utils/utils';


const ReportDriverOders = () => {
    const [DriverOrderData, setDriverOrderData] = useState([])
    useEffect(() => {
        getDriversOrders()
    }, [])
    const getDriversOrders=()=>{
        const data={}
        const url ='/report/getdriverOrders'
        sendData(url,data).then((response)=>{
            const driverOrder = response['orderDriver']
            setDriverOrderData(driverOrder)
            console.log(driverOrder)
        })
    }
    const cropDate = (dateStr) => {
        const date = new Date(dateStr);
        if(dateStr){

            return <span>{date.toLocaleDateString()}</span>;
        }
        else{
            return <span>Not Specified</span>; 
        }
    };

    const columns = [
        { title: 'Order #', dataIndex: 'code', key: 'code' },
  
        {
            title: 'Date',
            render: ({ created_at }) => cropDate(created_at),
            key: 'created_at',
            defaultSortOrder: 'descend',
            sorter: {
                compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
                multiple: 1
            }
        },
        {
            title: 'driver_img',
            render: ({ driver_img }) => (
                <div>
                  <img src={driver_img} alt="driver_img"/>
                </div>
            ), key: 'driver_img'
        },
        {
            title: 'driver_email',
            render: ({ driver_email }) => (
                <div>
                    <span>{driver_email?driver_email:'Not defined'}</span>
                </div>
            ),
            key: 'driver_email'
        },

        {
            title: 'driver_first_name',
            render: ({ driver_first_name }) => (
                <div>
                    <span>{driver_first_name?driver_first_name:'Not defined'}</span>
                </div>
            ),
            key: 'driver_first_name'
        },

      

        {
            title: 'PharmacyName',
            render: ({ PharmacyName }) => (
                <div>
                    <span>{PharmacyName}</span>
                </div>
            ),
            key: 'PharmacyName'
        },
        {
            title: 'total to deposit $',
            render: ({ deposit_amount }) => (
                <div>
                    <span>{formatter.format(deposit_amount-(((deposit_amount*0.03)+0.23)+((deposit_amount*0.03)+0.23)*0.105))}</span>
                </div>
            ),
            key: 'deposit_amount'
        },
    
        {
            title: 'Date',
            render: ({ stimated_paid_date }) => cropDate(stimated_paid_date),
            key: 'created_at',
            defaultSortOrder: 'ascend',
            //sortDirections: ['descend'],
            sorter: {
                compare: (a, b) => new Date(a.stimated_paid_date) > new Date(b.stimated_paid_date),
               // multiple: 1
            }
        },
    ];

    // const columns = [
    //     {
    //         title: 'Name',
    //         dataIndex: 'name',
    //         filters: [
    //             {
    //                 text: 'Joe',
    //                 value: 'Joe',
    //             },
    //             {
    //                 text: 'Jim',
    //                 value: 'Jim',
    //             },
    //             {
    //                 text: 'Submenu',
    //                 value: 'Submenu',
    //                 children: [
    //                     {
    //                         text: 'Green',
    //                         value: 'Green',
    //                     },
    //                     {
    //                         text: 'Black',
    //                         value: 'Black',
    //                     },
    //                 ],
    //             },
    //         ],
    //         // specify the condition of filtering result
    //         // here is that finding the name started with `value`
    //         onFilter: (value, record) => record.name.indexOf(value) === 0,
    //         sorter: (a, b) => a.name.length - b.name.length,
    //         sortDirections: ['descend'],
    //     },
    //     {
    //         title: 'Age',
    //         dataIndex: 'age',
    //         defaultSortOrder: 'descend',
    //         sorter: (a, b) => a.age - b.age,
    //     },
    //     {
    //         title: 'Address',
    //         dataIndex: 'address',
    //         filters: [
    //             {
    //                 text: 'London',
    //                 value: 'London',
    //             },
    //             {
    //                 text: 'New York',
    //                 value: 'New York',
    //             },
    //         ],
    //         onFilter: (value, record) => record.address.indexOf(value) === 0,
    //     },
    // ];
    // const data = [
    //     {
    //         key: '1',
    //         name: 'John Brown',
    //         age: 32,
    //         address: 'New York No. 1 Lake Park',
    //     },
    //     {
    //         key: '2',
    //         name: 'Jim Green',
    //         age: 42,
    //         address: 'London No. 1 Lake Park',
    //     },
    //     {
    //         key: '3',
    //         name: 'Joe Black',
    //         age: 32,
    //         address: 'Sidney No. 1 Lake Park',
    //     },
    //     {
    //         key: '4',
    //         name: 'Jim Red',
    //         age: 32,
    //         address: 'London No. 2 Lake Park',
    //     },
    // ];

    const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
    };

    return (
        <>

            <Table columns={columns} dataSource={DriverOrderData} onChange={onChange} />
        </>
    )

}
export default ReportDriverOders